import React from 'react';
import { Bathroom } from '@search/filter-enums/enums/Bathroom';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { BathroomFilter } from '../../../models/Filter';

interface IBathroomNewFilter {
    filter: BathroomFilter;
    handleChange: (value: BathroomFilter) => void;
    classNameGroup?: string;
}

const OPTIONS: OptionType<Bathroom>[] = [
    { label: 'Совмещённый', value: Bathroom.COMBINED },
    { label: 'Раздельный', value: Bathroom.PARTED },
    { label: 'Несколько', value: Bathroom.SEVERAL }
];

export const BathroomNewFilterView: React.FC<IBathroomNewFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, optionType: Bathroom) => {
        const filters = new Set(filter.value);

        filters[value ? 'add' : 'delete'](optionType);
        handleChange(new BathroomFilter(Array.from(filters)));
    }, [ handleChange, filter.value ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS.map(({ label, value }) => (
                <div key={value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={label}
                        value={filter.value.includes(value)}
                        onChange={v => onChange(v, value)}
                        variant='filter'
                        dataTest='bathroom'
                        block
                    >
                        {label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
